import React, { useEffect, useState } from 'react';
import TransactionHistoryPDF from '../components/TransactionHistoryPDF';

interface PDFData {
  transactions: Array<{
    id: string;
    date: string;
    time: string;
    senderCompany: string;
    receiverCompany: string;
    amount: number;
    status: string;
    protocolFee: number;
  }>;
  summary: {
    totalTransactions: number;
    totalAmount: number;
    totalFees: number;
    successRate: string;
  };
  reportDate: string;
  reportTime: string;
}

const TransactionHistoryPDFPage: React.FC = () => {
  const [pdfData, setPdfData] = useState<PDFData | null>(null);
  const [filename, setFilename] = useState<string>('');

  useEffect(() => {
    // Listen for messages from parent window
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      
      if (event.data.type === 'PDF_DATA') {
        setPdfData(event.data.data);
        setFilename(event.data.filename);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!pdfData) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#ef4444', marginBottom: '16px' }}>Error</h1>
          <p style={{ color: '#6b7280' }}>No PDF data available. Please try again.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f3f4f6',
      padding: '20px 0'
    }}>
      <TransactionHistoryPDF data={pdfData} filename={filename} />
    </div>
  );
};

export default TransactionHistoryPDFPage;
